import { action } from 'typesafe-actions';
import { PlantasTypes, SeatmapInterface } from './types';

// List Seatmaps
export const listSeatmapsRequest = (payload: object = {}) =>
  action(PlantasTypes.LIST_SEATMAPS_REQUEST, payload);

export const listSeatmapsSuccess = (payload: {
  seatmapsList: SeatmapInterface[];
  totalCount: number;
}) => action(PlantasTypes.LIST_SEATMAPS_SUCCESS, payload);

export const listSeatmapsFailure = () =>
  action(PlantasTypes.LIST_SEATMAPS_FAILURE);

// Get Seatmap
export const getSeatmapRequest = (payload: { id: string }) =>
  action(PlantasTypes.GET_SEATMAP_REQUEST, payload);

export const getSeatmapSuccess = (payload: {
  seatmapData: SeatmapInterface;
}) => action(PlantasTypes.GET_SEATMAP_SUCCESS, payload);

export const getSeatmapFailure = () =>
  action(PlantasTypes.GET_SEATMAP_FAILURE);

// Create Seatmap
export const createSeatmapRequest = (payload: object) =>
  action(PlantasTypes.CREATE_SEATMAP_REQUEST, payload);

export const createSeatmapSuccess = (payload: {
  seatmapData: SeatmapInterface;
}) => action(PlantasTypes.CREATE_SEATMAP_SUCCESS, payload);

export const createSeatmapFailure = () =>
  action(PlantasTypes.CREATE_SEATMAP_FAILURE);

// Update Seatmap
export const updateSeatmapRequest = (payload: object) =>
  action(PlantasTypes.UPDATE_SEATMAP_REQUEST, payload);

export const updateSeatmapSuccess = (payload: {
  seatmapData: SeatmapInterface;
}) => action(PlantasTypes.UPDATE_SEATMAP_SUCCESS, payload);

export const updateSeatmapFailure = () =>
  action(PlantasTypes.UPDATE_SEATMAP_FAILURE);

// Clear Seatmap Data
export const clearSeatmapData = () =>
  action(PlantasTypes.CLEAR_SEATMAP_DATA);

// Delete Seatmap
export const deleteSeatmapRequest = (payload: { id: string }) =>
  action(PlantasTypes.DELETE_SEATMAP_REQUEST, payload);

export const deleteSeatmapSuccess = () =>
  action(PlantasTypes.DELETE_SEATMAP_SUCCESS);

export const deleteSeatmapFailure = () =>
  action(PlantasTypes.DELETE_SEATMAP_FAILURE);
